import FormInputTypes from "../../components/atoms/formEnums/formInputTypes";

export default [{
    attributeName:'content',
    fields:[{
      attributeName: 'urlId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Interactable graphics',
      helpText: '  Select static image information.',
      fileType: ['image/*'],
      hasSelect:false
    }]
}]

